import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert
} from '@mui/material';
import api from '../../services/api';

/**
 * Item 82 — rename a portfolio (entity). Owner-only; the backend PATCH
 * /entities/:id enforces ownership and the 100-char limit. Works for the
 * default "My Portfolio" as well as any added entity.
 */
const RenameEntityDialog = ({ open, entity, onClose, onRenamed }) => {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // Pre-fill with the current name each time a different entity is opened.
  useEffect(() => {
    if (open && entity) {
      setName(entity.name || '');
      setError(null);
    }
  }, [open, entity]);

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) { setError('Name is required'); return; }
    setBusy(true);
    setError(null);
    try {
      await api.patch(`/entities/${entity.id}`, { name: trimmed });
      onRenamed?.(trimmed);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to rename portfolio');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Rename portfolio</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          fullWidth
          label="Portfolio name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && name.trim() && !busy) handleSave(); }}
          inputProps={{ maxLength: 100 }}
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={busy || !name.trim()}>
          {busy ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenameEntityDialog;
